export class ErrorMessage {
  public static readonly unexpected: string = '$error_unexpected';
  public static readonly unhandled: string = '$error_unhandled';
  public static readonly noSnackbar: string = 'do not open the snackbar'; // only used to make sure the error snackbar doesn't open
}
